import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const PriceInfo = ({ asset }) => {
  const [purchaseDate, setPurchaseDate] = useState("");
  const [manufactureDate, setManufactureDate] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [unitPrice, setUnitPrice] = useState("");

  // Converts date into YYYY-MM-DD for input fields
  const formatDate = (date) => {
    if (!date) return "";

    // Case 1: "2024-11-06 00:00:00"
    if (date.includes(" ")) return date.split(" ")[0];

    // Case 2: "06/11/2024"
    if (date.includes("/")) {
      const [dd, mm, yy] = date.split("/");
      return `${yy}-${mm}-${dd}`;
    }

    return date; // already in correct format
  };

  // Load asset data
  useEffect(() => {
    if (asset) {
      setPurchaseDate(formatDate(asset.purchase_date));
      setManufactureDate(formatDate(asset.manufacturer_date ?? asset.manufacture_date));
      setInvoiceNo(asset.invoice_number || "");
      setUnitPrice(asset.unit_price || "");
    }
  }, [asset]);

  const handleSave = async (e) => {
    e.preventDefault(); // prevent page refresh

    const payload = {
      asset_id: asset.assets_id,

      // NEW values
      purchase_date: purchaseDate,
      manufacture_date: manufactureDate,
      invoice_no: invoiceNo,
      unit_price: unitPrice,

      // OLD values for logs
      old_purchasedate: asset.purchase_date,
      old_manufacturedate: asset.manufacture_date ?? asset.manufacturer_date,
      old_invoiceno: asset.invoice_number,
      old_unitprice: asset.unit_price,
    };

    try {
      await axios.post(`${API_BASE_URL}/asset/price-info`, payload);

      toast.success("Price information updated!", {
        position: "bottom-right",
      });
    } catch (err) {
      console.error(err);
      toast.error("Failed to update!", {
        position: "bottom-right",
      });
    }
  };

  return (
    <div className="card p-3">
      <h5 className="mb-3">Price Information</h5>

      {/* FORM START */}
      <form onSubmit={handleSave}>
        <div className="row">

          {/* Purchase Date */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Purchase Date</label>
            <input
              type="date"
              className="form-control"
              value={purchaseDate}
              onChange={(e) => setPurchaseDate(e.target.value)}
            />
          </div>

          {/* Manufacture Date */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Manufacture Date</label>
            <input
              type="date"
              className="form-control"
              value={manufactureDate}
              onChange={(e) => setManufactureDate(e.target.value)}
            />
          </div>

          {/* Invoice No */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Invoice No</label>
            <input
              type="text"
              className="form-control"
              value={invoiceNo}
              onChange={(e) => setInvoiceNo(e.target.value)}
              placeholder="Enter Invoice Number"
            />
          </div>

          {/* Unit Price */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Unit Price</label>
            <input
              type="number"
              className="form-control"
              value={unitPrice}
              onChange={(e) => setUnitPrice(e.target.value)}
              placeholder="Enter Unit Price"
            />
          </div>

        </div>

        {/* Save Button */}
        <button className="btn btn-primary btn-sm mt-2" type="submit">
          Save
        </button>
      </form>
      {/* FORM END */}

    </div>
  );
};

export default PriceInfo;
